import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  supplierDetails: {
    id: 'GJlZdF',
    defaultMessage: 'Supplier details',
    description: 'Header for the supplier details section in the purchase order page',
  },
  contactDetails: {
    id: 'p7oud8',
    defaultMessage: 'Contact details',
    description: 'Header for the supplier field in the supplier details section',
  },
  supplierProducts: {
    id: 'GBKqs9',
    defaultMessage: 'Supplier SKUs',
    description: 'Header for the supplier products section',
  },
  noProductsFound: {
    id: 'nrKERM',
    defaultMessage: 'No products found for this supplier.',
    description: 'Empty state message when supplier has no products',
  },
  productsSummary: {
    id: 'WujRzS',
    defaultMessage: 'Showing {start}-{end} of {total} products',
    description: 'Summary text showing product count',
  },
  addProductButton: {
    id: 't1CVX4',
    defaultMessage: 'Add Product',
    description: 'Button text to add a new product to the supplier',
  },
  deleteSuccessTitle: {
    id: 'suTbI4',
    defaultMessage: 'Product Removed',
    description: 'Success notification title for delete',
  },
  deleteSuccessContent: {
    id: '5tF0Ex',
    defaultMessage: 'The product has been removed successfully.',
    description: 'Success notification content for delete',
  },
  deleteErrorTitle: {
    id: 'QkTf3V',
    defaultMessage: 'Error',
    description: 'Error notification title for delete',
  },
  deleteErrorContent: {
    id: 'n2u68R',
    defaultMessage: 'Failed to remove the product. Please try again.',
    description: 'Error notification content for delete',
  },
  fetchProductsErrorTitle: {
    id: 'XtcQyM',
    defaultMessage: 'Error Loading Products',
    description: 'Error notification title when fetching supplier products fails',
  },
  fetchProductsErrorContent: {
    id: 'ucI0XT',
    defaultMessage: 'Failed to load supplier products. Please try again.',
    description: 'Error notification content when fetching supplier products fails',
  },
});
